import { Coordinate, Project, Ruler } from "@nova/protobuf"
import {
    coordinatesValidators,
    createLayerValidator,
    enumValidator,
    genericUpdateLayerValidator,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { AreaUnit, DistanceUnit, GeometryType } from "@nova/constants"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"

const coordinatesValidator = [
    {
        validator: (val: Coordinate[], args: Partial<Ruler>) => {
            return args.geometryType === GeometryType.Line ? val.length > 1 : val.length > 2
        },
        error: "Ruler does not have enough vertices",
    },
    ...coordinatesValidators,
]

const distanceUnitValidator = [
    {
        validator: (val: string) => Object.values(DistanceUnit).includes(val as DistanceUnit),
        error: "Distance unit is invalid",
    },
]

const areaUnitValidator = [
    {
        validator: (val: string) => Object.values(AreaUnit).includes(val as AreaUnit),
        error: "Area unit is invalid",
    },
]

export const createRulerValidator = createLayerValidator(Ruler, {
    coordinates: { validators: coordinatesValidator, nonNull: true },
    geometryType: { validators: enumValidator("type", GeometryType), nonNull: true },
    distanceUnit: { validators: distanceUnitValidator, nonNull: true },
    areaUnit: { validators: areaUnitValidator, nonNull: true },
    parentId: genericUpdateLayerValidator.parentId,
})

export const updateRulerValidator = updateLayerValidator(Ruler, {
    coordinates: { validators: coordinatesValidator, nonNull: true },
    geometryType: { validators: enumValidator("type", GeometryType), nonNull: true },
    distanceUnit: { validators: distanceUnitValidator, nonNull: true },
    areaUnit: { validators: areaUnitValidator, nonNull: true },
})

export const getDefaultRulerCreateArgs = (project: Project, inParentId?: string) => ({
    visible: true,
    createdAt: dateAsNumber(),
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    // parentId would never got autopopulated
    parentId: undefined,
})

export type CreateRulerArgs = UnionToTuple<keyof typeof createRulerValidator>
export type UpdateRulerArgs = UnionToTuple<keyof typeof updateRulerValidator>
